/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="1460" height="40" {...props}>
    <path
      fill="#BB2F29"
      d="M882 21a5 5 0 00-5-5H467a5 5 0 00-5 5v14a5 5 0 005 5h410a5 5 0 005-5V21z"
    ></path>
    <path
      fill="#C97740"
      d="M439 13a5 5 0 00-5-5H168a5 5 0 00-5 5v22a5 5 0 005 5h266a5 5 0 005-5V13z"
    ></path>
    <path
      fill="#DD5A3D"
      d="M1460 30a5 5 0 00-5-5H909a5 5 0 00-5 5v5a5 5 0 005 5h546a5 5 0 005-5v-5z"
    ></path>
    <rect
      width="141"
      height="40"
      fill="#E8CD4B"
      rx="5"
      transform="matrix(-1 0 0 1 141 0)"
    ></rect>
  </Svg>
)

export default Icon
